export default "__VITE_ASSET__7e6fdbb1__"